import { IComponentAsset, ILibraryAsset } from '../registry.types';

export function filterChunkAssets(
  assets: Array<IComponentAsset>,
  name?: string,
) {
  return assets.filter(asset => (name ? asset.chunk === name : !!asset.chunk));
}
export function filterDependencyAssets(assets: Array<IComponentAsset>) {
  return assets.filter(asset => !!asset.dependency);
}

export function filterComponentAssets(assets: Array<IComponentAsset>) {
  return assets.filter(asset => !asset.part && !asset.dependency);
}

export function filterPartAssets(
  assets: Array<IComponentAsset>,
  part?: string,
) {
  return assets.filter(asset => (part ? asset.part === part : !!asset.part));
}

export function filterStyleAssets<
  TAsset extends ILibraryAsset | IComponentAsset,
>(assets: Array<TAsset>) {
  return assets.filter(
    asset => asset.type === 'style' && isCSS(asset.extension),
  );
}

export function filterModelAssets<
  TAsset extends ILibraryAsset | IComponentAsset,
>(assets: Array<TAsset>) {
  return assets.filter(
    asset => asset.type === 'model' && isJS(asset.extension),
  );
}

export function getComponentAssetsOrder(assets: Array<IComponentAsset>) {
  return [
    ...assets.filter(asset => asset.chunk && !asset.part),
    ...assets.filter(asset => !asset.chunk && !asset.part),
  ];
}

export function filterWebpackRuntimeAsset(assets: Array<ILibraryAsset>) {
  return assets.filter(asset => asset.type === 'webpack-runtime');
}

export function getExtension(url: string) {
  return url.split('.').pop();
}

export function getAssetsTypeByExtension(extension: string) {
  if (isJS(extension)) {
    return 'model';
  } else if (isCSS(extension)) {
    return 'style';
  } else {
    return 'unknown';
  }
}

export function isJS(extension: string | undefined) {
  return extension === 'js';
}

export function isCSS(extension: string | undefined) {
  return extension === 'css';
}
